import styled from "styled-components";
import Image from "../../../../../base/multimedia/image/index.js";
import { BoxShadow, BoxShadowHover } from "../../../../../../styles/common/mixins/box-shadow.styled.js";
import { FlexMixin } from "../../../../../../styles/common/mixins/helpers.styled.js";
export const ComarketingWrapper = styled.div.withConfig({
    displayName: "styled__ComarketingWrapper",
    componentId: "sc-22796757-0"
})`
	${FlexMixin({
    justify: 'space-between'
})}

	${({ theme  })=>theme.media.down('lg')} {
		${FlexMixin({
    direction: 'column'
})}
	}

	&:only-child {
		${FlexMixin({
    justify: 'center'
})}
	}
`;
export const ComarketingImage = styled(Image).withConfig({
    displayName: "styled__ComarketingImage",
    componentId: "sc-22796757-1"
})`
	${BoxShadow}
	${BoxShadowHover}

  & img {
		height: auto;
		width: 100%;
	}

	${({ theme  })=>theme.media.down('lg')} {
		margin-bottom: 20px;
		margin-right: 0;
	}

	${({ theme  })=>theme.media.up('lg')} {
		margin-right: 20px;
	}

	${({ theme  })=>theme.media.up('xl')} {
		margin-right: 30px;
	}
`;

//# sourceMappingURL=styled.js.map